import React, { useState } from 'react';
import { 
  Lock,
  Key,
  Shield,
  Users,
  CheckCircle,
  XCircle,
  AlertTriangle,
  Clock,
  Eye,
  Trash2,
  Download,
  Plus,
  Edit,
  Save,
  X,
  Search,
  Filter,
  MoreHorizontal,
  Bookmark,
  Star,
  Share,
  Info,
  ExternalLink,
  Archive,
  Send,
  Flag,
  Heart,
  ThumbsUp,
  ThumbsDown,
  Upload,
  FileUp,
  FileDown,
  FileCheck,
  FileX,
  Volume2,
  VolumeX,
  Headphones,
  Speaker,
  Radio,
  Music,
  Video,
  Camera,
  Image,
  File,
  Folder,
  FolderOpen,
  HardDrive,
  Cloud,
  Wifi,
  WifiOff,
  Signal,
  Battery,
  BatteryLow,
  Power,
  PowerOff,
  Activity,
  Zap,
  Building,
  Calendar,
  Phone,
  Mail,
  MapPin,
  CheckSquare,
  Square as SquareIcon,
  ArrowUpRight,
  ArrowDownRight,
  ArrowLeft,
  Home,
  Wrench,
  FileBarChart,
  Cog,
  Settings,
  Link,
  Monitor,
  Tablet,
  Smartphone,
  Lightbulb,
  Cpu,
  Network,
  Database,
  Layers,
  User,
  Languages,
  Mic,
  Play,
  Pause,
  Square,
  RefreshCw,
  Copy,
  Globe,
  Users2,
  AlertTriangle as AlertTriangleIcon,
  CheckCircle as CheckCircleIcon,
  XCircle as XCircleIcon,
  Clock as ClockIcon,
  Target,
  Brain,
  MessageSquare,
  AlertCircle,
  CheckSquare as CheckSquareIcon,
  Receipt,
  Bot,
  Scan,
  Zap as ZapIcon,
  Shield as ShieldIcon,
  LineChart,
  BarChart,
  PieChart,
  AreaChart,
  TrendingUp,
  TrendingDown,
  ArrowUp,
  ArrowDown,
  Minus,
  Percent,
  Calendar as CalendarIcon,
  AlertCircle as AlertCircleIcon,
  Info as InfoIcon,
  Lightbulb as LightbulbIcon,
  Award,
  Gift,
  Coins,
  Wallet,
  PiggyBank,
  Banknote,
  Receipt as ReceiptIcon,
  ShoppingCart,
  Package,
  Truck,
  Building2,
  Factory,
  Store,
  Home as HomeIcon,
  Car,
  Plane,
  Train,
  Ship,
  Fuel,
  Wrench as WrenchIcon,
  Tool,
  Hammer,
  Screwdriver,
  Cog as CogIcon,
  Settings as SettingsIcon,
  BarChart as BarChartIcon,
  PieChart as PieChartIcon,
  Activity as ActivityIcon,
  Zap as ZapIcon2,
  Target as TargetIcon,
  Brain as BrainIcon,
  Database as DatabaseIcon,
  Layers as LayersIcon,
  Network as NetworkIcon,
  Cpu as CpuIcon,
  Monitor as MonitorIcon,
  Smartphone as SmartphoneIcon,
  Tablet as TabletIcon,
  Globe as GlobeIcon,
  Users as UsersIcon,
  Building as BuildingIcon,
  Home as HomeIcon2,
  Car as CarIcon,
  Plane as PlaneIcon,
  Train as TrainIcon,
  Ship as ShipIcon,
  Truck as TruckIcon,
  Package as PackageIcon,
  ShoppingCart as ShoppingCartIcon,
  Receipt as ReceiptIcon2,
  Banknote as BanknoteIcon,
  PiggyBank as PiggyBankIcon,
  Wallet as WalletIcon,
  Coins as CoinsIcon,
  Gift as GiftIcon,
  Award as AwardIcon,
  Lightbulb as LightbulbIcon2,
  Info as InfoIcon2,
  AlertCircle as AlertCircleIcon2,
  Clock as ClockIcon2,
  Calendar as CalendarIcon2,
  Percent as PercentIcon,
  Minus as MinusIcon,
  ArrowDown as ArrowDownIcon,
  ArrowUp as ArrowUpIcon,
  TrendingDown as TrendingDownIcon,
  TrendingUp as TrendingUpIcon,
  AreaChart as AreaChartIcon,
  Shield as ShieldIcon2,
  Scan as ScanIcon,
  Bot as BotIcon,
  CheckSquare as CheckSquareIcon2,
  MessageSquare as MessageSquareIcon,
  Brain as BrainIcon2,
  Target as TargetIcon2,
  Zap as ZapIcon3,
  Activity as ActivityIcon2,
  BarChart as BarChartIcon2,
  PieChart as PieChartIcon2,
  LineChart as LineChartIcon,
  TrendingDown as TrendingDownIcon2,
  TrendingUp as TrendingUpIcon2,
  Calculator as CalculatorIcon,
  CreditCard as CreditCardIcon,
  DollarSign as DollarSignIcon,
  FileText as FileTextIcon,
  Eye as EyeIcon,
  Trash2 as Trash2Icon,
  Edit as EditIcon,
  Save as SaveIcon,
  X as XIcon,
  Plus as PlusIcon,
  Search as SearchIcon,
  Filter as FilterIcon,
  MoreHorizontal as MoreHorizontalIcon,
  Bookmark as BookmarkIcon,
  Star as StarIcon,
  Share as ShareIcon,
  Info as InfoIcon3,
  ExternalLink as ExternalLinkIcon,
  Archive as ArchiveIcon,
  Send as SendIcon,
  Flag as FlagIcon,
  Heart as HeartIcon,
  ThumbsUp as ThumbsUpIcon,
  ThumbsDown as ThumbsDownIcon,
  Upload as UploadIcon,
  FileUp as FileUpIcon,
  FileDown as FileDownIcon,
  FileCheck as FileCheckIcon,
  FileX as FileXIcon,
  Volume2 as Volume2Icon,
  VolumeX as VolumeXIcon,
  Headphones as HeadphonesIcon,
  Speaker as SpeakerIcon,
  Radio as RadioIcon,
  Music as MusicIcon,
  Video as VideoIcon,
  Camera as CameraIcon,
  Image as ImageIcon,
  File as FileIcon,
  Folder as FolderIcon,
  FolderOpen as FolderOpenIcon,
  HardDrive as HardDriveIcon,
  Cloud as CloudIcon,
  Wifi as WifiIcon,
  WifiOff as WifiOffIcon,
  Signal as SignalIcon,
  Battery as BatteryIcon,
  BatteryLow as BatteryLowIcon,
  Power as PowerIcon,
  PowerOff as PowerOffIcon,
  Activity as ActivityIcon3,
  Zap as ZapIcon4,
  Shield as ShieldIcon3,
  Lock as LockIcon,
  Key as KeyIcon,
  Users as UsersIcon2,
  Building as BuildingIcon2,
  Calendar as CalendarIcon3,
  Phone as PhoneIcon,
  Mail as MailIcon,
  MapPin as MapPinIcon,
  CheckSquare as CheckSquareIcon3,
  Square as SquareIcon2,
  ArrowUpRight as ArrowUpRightIcon,
  ArrowDownRight as ArrowDownRightIcon,
  ArrowLeft as ArrowLeftIcon,
  Home as HomeIcon3,
  Wrench as WrenchIcon2,
  FileBarChart as FileBarChartIcon,
  Cog as CogIcon2,
  Settings as SettingsIcon2,
  Link as LinkIcon,
  Monitor as MonitorIcon2,
  Tablet as TabletIcon2,
  Smartphone as SmartphoneIcon2,
  Lightbulb as LightbulbIcon3,
  Cpu as CpuIcon2,
  Network as NetworkIcon2,
  Database as DatabaseIcon2,
  Layers as LayersIcon2,
  User as UserIcon,
  Languages as LanguagesIcon,
  Mic as MicIcon,
  Play as PlayIcon,
  Pause as PauseIcon,
  Square as SquareIcon3,
  RefreshCw as RefreshCwIcon,
  Copy as CopyIcon,
  Download as DownloadIcon,
  Globe as GlobeIcon2,
  Users2 as Users2Icon,
  AlertTriangle as AlertTriangleIcon2,
  CheckCircle as CheckCircleIcon2,
  XCircle as XCircleIcon2,
  Clock as ClockIcon3,
  Target as TargetIcon3,
  Brain as BrainIcon3,
  MessageSquare as MessageSquareIcon2,
  AlertCircle as AlertCircleIcon3,
  CheckSquare as CheckSquareIcon4
} from 'lucide-react';
import DataTable from '../common/DataTable';
import ConfirmationModal from '../common/ConfirmationModal';

const SSOIntegration = () => {
  const [activeTab, setActiveTab] = useState('identity-providers');
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);
  const [showExportModal, setShowExportModal] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);

  // Mock data for identity providers
  const [identityProviders, setIdentityProviders] = useState([
    {
      id: 'IDP-001',
      providerName: 'Microsoft Azure AD',
      providerType: 'SAML 2.0',
      status: 'Active',
      domain: 'company.com',
      users: 1250,
      lastSync: '2024-02-15 14:30:00',
      syncFrequency: 'Real-time',
      authenticationMethod: 'SAML',
      certificateExpiry: '2024-12-31',
      isActive: true,
      tags: ['azure', 'saml', 'enterprise'],
      isBookmarked: true,
      isStarred: true,
      viewCount: 234,
      downloadCount: 15,
      aiInsights: ['Provider configured correctly', 'Certificate valid', 'High user adoption'],
      keyMetrics: {
        successRate: '99.8%',
        averageResponseTime: '45ms',
        failedLogins: '12',
        activeUsers: '1,250'
      },
      alerts: ['Certificate expires in 10 months'],
      performanceScore: 96.2
    },
    {
      id: 'IDP-002',
      providerName: 'Google Workspace',
      providerType: 'OAuth 2.0',
      status: 'Active',
      domain: 'company.com',
      users: 890,
      lastSync: '2024-02-15 14:25:00',
      syncFrequency: 'Hourly',
      authenticationMethod: 'OAuth',
      certificateExpiry: '2025-06-15',
      isActive: true,
      tags: ['google', 'oauth', 'workspace'],
      isBookmarked: true,
      isStarred: false,
      viewCount: 189,
      downloadCount: 12,
      aiInsights: ['Good performance', 'OAuth configured properly', 'Regular sync working'],
      keyMetrics: {
        successRate: '98.5%',
        averageResponseTime: '120ms',
        failedLogins: '8',
        activeUsers: '890'
      },
      alerts: [],
      performanceScore: 92.8
    },
    {
      id: 'IDP-003',
      providerName: 'Okta',
      providerType: 'SAML 2.0',
      status: 'Inactive',
      domain: 'company.com',
      users: 0,
      lastSync: '2024-01-15 10:00:00',
      syncFrequency: 'Disabled',
      authenticationMethod: 'SAML',
      certificateExpiry: '2024-03-31',
      isActive: false,
      tags: ['okta', 'saml', 'inactive'],
      isBookmarked: false,
      isStarred: false,
      viewCount: 45,
      downloadCount: 3,
      aiInsights: ['Provider inactive', 'Certificate expiring soon', 'No active users'],
      keyMetrics: {
        successRate: '0%',
        averageResponseTime: 'N/A',
        failedLogins: '0',
        activeUsers: '0'
      },
      alerts: ['Certificate expires in 1 month', 'Provider inactive'],
      performanceScore: 0
    }
  ]);

  // Mock data for access control policies
  const [accessPolicies, setAccessPolicies] = useState([
    {
      id: 'POLICY-001',
      policyName: 'Admin Access Policy',
      description: 'Full administrative access to all systems',
      status: 'Active',
      userCount: 15,
      applications: ['All Systems'],
      conditions: ['Role: Admin', 'MFA Required'],
      lastModified: '2024-02-10',
      createdBy: 'Security Admin',
      isActive: true,
      tags: ['admin', 'full-access', 'mfa'],
      isBookmarked: true,
      isStarred: true,
      viewCount: 156,
      downloadCount: 8,
      aiInsights: ['High-privilege policy', 'MFA properly configured', 'Limited user count'],
      keyMetrics: {
        policyViolations: '0',
        accessAttempts: '245',
        successRate: '100%',
        averageAccessTime: '2.5 hours'
      },
      alerts: [],
      performanceScore: 98.5
    },
    {
      id: 'POLICY-002',
      policyName: 'Contract Management Access',
      description: 'Access to contract management system for authorized users',
      status: 'Active',
      userCount: 45,
      applications: ['Contract Management', 'Document Storage'],
      conditions: ['Role: Contract Manager', 'Department: Legal'],
      lastModified: '2024-02-08',
      createdBy: 'IT Admin',
      isActive: true,
      tags: ['contracts', 'legal', 'departmental'],
      isBookmarked: false,
      isStarred: false,
      viewCount: 89,
      downloadCount: 5,
      aiInsights: ['Department-specific access', 'Appropriate user count', 'Clear conditions'],
      keyMetrics: {
        policyViolations: '2',
        accessAttempts: '1,250',
        successRate: '99.8%',
        averageAccessTime: '4.2 hours'
      },
      alerts: ['2 policy violations detected'],
      performanceScore: 87.3
    }
  ]);

  // Calculate statistics
  const stats = {
    totalProviders: identityProviders.length,
    activeProviders: identityProviders.filter(p => p.status === 'Active').length,
    inactiveProviders: identityProviders.filter(p => p.status === 'Inactive').length,
    totalUsers: identityProviders.reduce((sum, provider) => sum + provider.users, 0),
    totalPolicies: accessPolicies.length,
    activePolicies: accessPolicies.filter(p => p.status === 'Active').length,
    totalPolicyUsers: accessPolicies.reduce((sum, policy) => sum + policy.userCount, 0),
    averageSuccessRate: identityProviders.reduce((sum, provider) => {
      const rate = parseFloat(provider.keyMetrics.successRate.replace('%', ''));
      return sum + rate;
    }, 0) / identityProviders.length
  };

  const tabs = [
    { id: 'identity-providers', label: 'Identity Providers' },
    { id: 'access-policies', label: 'Access Policies' },
    { id: 'user-mapping', label: 'User Mapping' },
    { id: 'audit-logs', label: 'Audit Logs' }
  ];

  // Define columns for Identity Providers DataTable
  const identityProvidersColumns = [
    {
      key: 'providerName',
      label: 'Provider Details',
      width: '250px',
      render: (value, row) => (
        <div>
          <div style={{ fontWeight: '500', color: '#1f2937', marginBottom: '4px' }}>{value}</div>
          <div style={{ fontSize: '12px', color: '#6b7280' }}>
            {row.providerType} • {row.domain}
          </div>
        </div>
      )
    },
    {
      key: 'status',
      label: 'Status',
      width: '100px',
      render: (status) => {
        const statusConfig = {
          'Active': { color: '#10b981', bg: '#d1fae5' },
          'Inactive': { color: '#6b7280', bg: '#f3f4f6' },
          'Error': { color: '#ef4444', bg: '#fee2e2' }
        };
        const config = statusConfig[status] || statusConfig['Active'];
        
        return (
          <span style={{
            padding: '4px 8px',
            borderRadius: '4px',
            fontSize: '12px',
            fontWeight: '500',
            backgroundColor: config.bg,
            color: config.color
          }}>
            {status}
          </span>
        );
      }
    },
    {
      key: 'users',
      label: 'Users',
      width: '80px',
      render: (count) => (
        <span style={{ fontWeight: '500', color: '#007B8F' }}>{count.toLocaleString()}</span>
      )
    },
    {
      key: 'authenticationMethod',
      label: 'Auth Method',
      width: '120px',
      render: (method) => (
        <span style={{ fontWeight: '500', color: '#1f2937' }}>{method}</span>
      )
    },
    {
      key: 'lastSync',
      label: 'Last Sync',
      width: '140px',
      render: (time) => (
        <span style={{ fontWeight: '500', color: '#1f2937' }}>{time}</span>
      )
    },
    {
      key: 'syncFrequency',
      label: 'Sync Frequency',
      width: '120px',
      render: (frequency) => (
        <span style={{ fontWeight: '500', color: '#007B8F' }}>{frequency}</span>
      )
    },
    {
      key: 'certificateExpiry',
      label: 'Cert Expiry',
      width: '120px',
      render: (date) => {
        const expiryDate = new Date(date);
        const today = new Date();
        const daysUntilExpiry = Math.ceil((expiryDate - today) / (1000 * 60 * 60 * 24));
        const isExpiringSoon = daysUntilExpiry <= 30;
        
        return (
          <span style={{ 
            fontWeight: '500', 
            color: isExpiringSoon ? '#ef4444' : '#1f2937' 
          }}>
            {new Date(date).toLocaleDateString()}
          </span>
        );
      }
    },
    {
      key: 'actions',
      label: 'Actions',
      width: '200px',
      render: (value, row) => (
        <div style={{ display: 'flex', gap: '6px' }}>
          <button
            onClick={() => handleView(row)}
            style={{
              padding: '6px 10px',
              fontSize: '12px',
              borderRadius: '6px',
              borderColor: '#007B8F',
              color: '#007B8F',
              backgroundColor: 'transparent',
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            }}
            title="View Details"
          >
            <Eye size={14} /> View
          </button>
          <button
            onClick={() => handleExport(row)}
            style={{
              padding: '6px 10px',
              fontSize: '12px',
              borderRadius: '6px',
              borderColor: '#10b981',
              color: '#10b981',
              backgroundColor: 'transparent',
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            }}
            title="Export Provider"
          >
            <Download size={14} /> Export
          </button>
          <button
            onClick={() => handleDelete(row)}
            style={{
              padding: '6px 10px',
              fontSize: '12px',
              borderRadius: '6px',
              borderColor: '#ef4444',
              color: '#ef4444',
              backgroundColor: 'transparent',
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            }}
            title="Delete Provider"
          >
            <Trash2 size={14} /> Delete
          </button>
        </div>
      )
    }
  ];

  // Define columns for Access Policies DataTable
  const accessPoliciesColumns = [
    {
      key: 'policyName',
      label: 'Policy Details',
      width: '250px',
      render: (value, row) => (
        <div>
          <div style={{ fontWeight: '500', color: '#1f2937', marginBottom: '4px' }}>{value}</div>
          <div style={{ fontSize: '12px', color: '#6b7280' }}>
            {row.description}
          </div>
        </div>
      )
    },
    {
      key: 'status',
      label: 'Status',
      width: '100px',
      render: (status) => {
        const statusConfig = {
          'Active': { color: '#10b981', bg: '#d1fae5' },
          'Inactive': { color: '#6b7280', bg: '#f3f4f6' },
          'Draft': { color: '#f59e0b', bg: '#fef3c7' }
        };
        const config = statusConfig[status] || statusConfig['Active'];
        
        return (
          <span style={{
            padding: '4px 8px',
            borderRadius: '4px',
            fontSize: '12px',
            fontWeight: '500',
            backgroundColor: config.bg,
            color: config.color
          }}>
            {status}
          </span>
        );
      }
    },
    {
      key: 'userCount',
      label: 'Users',
      width: '80px',
      render: (count) => (
        <span style={{ fontWeight: '500', color: '#007B8F' }}>{count}</span>
      )
    },
    {
      key: 'applications',
      label: 'Applications',
      width: '150px',
      render: (apps) => (
        <span style={{ fontWeight: '500', color: '#1f2937' }}>
          {Array.isArray(apps) ? apps.join(', ') : apps}
        </span>
      )
    },
    {
      key: 'conditions',
      label: 'Conditions',
      width: '150px',
      render: (conditions) => (
        <span style={{ fontWeight: '500', color: '#1f2937' }}>
          {Array.isArray(conditions) ? conditions.join(', ') : conditions}
        </span>
      )
    },
    {
      key: 'lastModified',
      label: 'Last Modified',
      width: '120px',
      render: (date) => new Date(date).toLocaleDateString()
    },
    {
      key: 'createdBy',
      label: 'Created By',
      width: '120px',
      render: (creator) => (
        <span style={{ fontWeight: '500', color: '#1f2937' }}>{creator}</span>
      )
    },
    {
      key: 'actions',
      label: 'Actions',
      width: '200px',
      render: (value, row) => (
        <div style={{ display: 'flex', gap: '6px' }}>
          <button
            onClick={() => handleView(row)}
            style={{
              padding: '6px 10px',
              fontSize: '12px',
              borderRadius: '6px',
              borderColor: '#007B8F',
              color: '#007B8F',
              backgroundColor: 'transparent',
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            }}
            title="View Details"
          >
            <Eye size={14} /> View
          </button>
          <button
            onClick={() => handleExport(row)}
            style={{
              padding: '6px 10px',
              fontSize: '12px',
              borderRadius: '6px',
              borderColor: '#10b981',
              color: '#10b981',
              backgroundColor: 'transparent',
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            }}
            title="Export Policy"
          >
            <Download size={14} /> Export
          </button>
          <button
            onClick={() => handleDelete(row)}
            style={{
              padding: '6px 10px',
              fontSize: '12px',
              borderRadius: '6px',
              borderColor: '#ef4444',
              color: '#ef4444',
              backgroundColor: 'transparent',
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            }}
            title="Delete Policy"
          >
            <Trash2 size={14} /> Delete
          </button>
        </div>
      )
    }
  ];

  // Handler functions
  const handleView = (item) => {
    //console.log('Viewing item:', item.providerName || item.policyName);
  };

  const handleExport = (item) => {
    setSelectedItem(item);
    setShowExportModal(true);
  };

  const handleDelete = (item) => {
    setSelectedItem(item);
    setShowDeleteModal(true);
  };

  const handleDeleteConfirm = async () => {
    setIsDeleting(true);
    try {
      if (activeTab === 'identity-providers') {
        setIdentityProviders(prev => prev.filter(provider => provider.id !== selectedItem.id));
      } else {
        setAccessPolicies(prev => prev.filter(policy => policy.id !== selectedItem.id));
      }
      setShowDeleteModal(false);
      setSelectedItem(null);
    } catch (error) {
      console.error('Error deleting item:', error);
    } finally {
      setIsDeleting(false);
    }
  };

  const handleExportConfirm = async () => {
    setIsProcessing(true);
    try {
      setShowExportModal(false);
      setSelectedItem(null);
    } catch (error) {
      console.error('Error exporting report:', error);
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <div style={{
      padding: '24px',
      fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
      backgroundColor: '#f8fafc',
      minHeight: '100vh'
    }}>
      {/* Header */}
      <div style={{ marginBottom: '32px' }}>
        <h1 style={{
          fontSize: '32px',
          fontWeight: '700',
          color: '#1f2937',
          margin: '0 0 8px 0',
          background: 'linear-gradient(135deg, #007B8F 0%, #4A9BA8 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent'
        }}>
          SSO & Access Control
        </h1>
        <p style={{
          fontSize: '16px',
          color: '#6b7280',
          margin: 0
        }}>
          Manage single sign-on authentication and access control policies
        </p>
      </div>

      {/* Tabbed Navigation */}
      <div style={{ marginBottom: '32px' }}>
        <div style={{
          display: 'flex',
          borderBottom: '1px solid #e5e7eb',
          gap: '0'
        }}>
          {tabs.map(tab => (
            <button
              key={tab.id}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                padding: '12px 24px',
                color: activeTab === tab.id ? '#007B8F' : '#6b7280',
                borderBottom: activeTab === tab.id ? '3px solid #007B8F' : '3px solid transparent',
                transition: 'all 0.15s ease-in-out',
                fontWeight: '500',
                fontSize: '14px',
                backgroundColor: 'transparent',
                border: 'none',
                cursor: 'pointer',
                borderRadius: '6px 6px 0 0',
                fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
                position: 'relative',
                marginBottom: '-1px'
              }}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.id === 'identity-providers' && <Shield size={18} style={{ color: activeTab === tab.id ? '#007B8F' : '#9ca3af' }} />}
              {tab.id === 'access-policies' && <Lock size={18} style={{ color: activeTab === tab.id ? '#007B8F' : '#9ca3af' }} />}
              {tab.id === 'user-mapping' && <Users size={18} style={{ color: activeTab === tab.id ? '#007B8F' : '#9ca3af' }} />}
              {tab.id === 'audit-logs' && <FileTextIcon size={18} style={{ color: activeTab === tab.id ? '#007B8F' : '#9ca3af' }} />}
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {/* Stats Cards */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
        gap: '24px',
        marginBottom: '32px'
      }}>
        <div style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: '20px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          border: '1px solid #e5e7eb'
        }}>
          <div>
            <p style={{ fontSize: '14px', color: '#6b7280', margin: '0 0 8px 0' }}>Identity Providers</p>
            <h2 style={{ fontSize: '28px', fontWeight: '700', color: '#1f2937', margin: 0 }}>{stats.totalProviders}</h2>
            <p style={{ fontSize: '12px', color: '#6b7280', margin: '4px 0 0 0' }}>
              {stats.activeProviders} active, {stats.inactiveProviders} inactive
            </p>
          </div>
          <div style={{
            width: '48px',
            height: '48px',
            borderRadius: '12px',
            backgroundColor: '#007B8F20',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#007B8F'
          }}>
            <Shield size={20} />
          </div>
        </div>

        <div style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: '20px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          border: '1px solid #e5e7eb'
        }}>
          <div>
            <p style={{ fontSize: '14px', color: '#6b7280', margin: '0 0 8px 0' }}>Total Users</p>
            <h2 style={{ fontSize: '28px', fontWeight: '700', color: '#1f2937', margin: 0 }}>
              {stats.totalUsers.toLocaleString()}
            </h2>
            <p style={{ fontSize: '12px', color: '#6b7280', margin: '4px 0 0 0' }}>
              SSO enabled users
            </p>
          </div>
          <div style={{
            width: '48px',
            height: '48px',
            borderRadius: '12px',
            backgroundColor: '#10b98120',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#10b981'
          }}>
            <Users size={20} />
          </div>
        </div>

        <div style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: '20px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          border: '1px solid #e5e7eb'
        }}>
          <div>
            <p style={{ fontSize: '14px', color: '#6b7280', margin: '0 0 8px 0' }}>Access Policies</p>
            <h2 style={{ fontSize: '28px', fontWeight: '700', color: '#1f2937', margin: 0 }}>{stats.totalPolicies}</h2>
            <p style={{ fontSize: '12px', color: '#6b7280', margin: '4px 0 0 0' }}>
              {stats.activePolicies} active policies
            </p>
          </div>
          <div style={{
            width: '48px',
            height: '48px',
            borderRadius: '12px',
            backgroundColor: '#f59e0b20',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#f59e0b'
          }}>
            <Lock size={20} />
          </div>
        </div>

        <div style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: '20px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          border: '1px solid #e5e7eb'
        }}>
          <div>
            <p style={{ fontSize: '14px', color: '#6b7280', margin: '0 0 8px 0' }}>Avg Success Rate</p>
            <h2 style={{ fontSize: '28px', fontWeight: '700', color: '#1f2937', margin: 0 }}>
              {stats.averageSuccessRate.toFixed(1)}%
            </h2>
            <p style={{ fontSize: '12px', color: '#6b7280', margin: '4px 0 0 0' }}>
              Authentication success
            </p>
          </div>
          <div style={{
            width: '48px',
            height: '48px',
            borderRadius: '12px',
            backgroundColor: '#ef444420',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#ef4444'
          }}>
            <CheckCircle size={20} />
          </div>
        </div>
      </div>

      {/* Identity Providers Tab */}
      {activeTab === 'identity-providers' && (
        <div>
          <div style={{ overflowX: 'auto', maxWidth: '100%' }}>
            <DataTable
              data={identityProviders}
              columns={identityProvidersColumns}
              title={`Identity Providers (${identityProviders.length} providers)`}
              searchable={false}
              sortable={true}
              exportable={true}
              pagination={true}
              pageSize={10}
              hiddenColumns={['none']}
              onHiddenColumnsChange={() => {}}
            />
          </div>
        </div>
      )}

      {/* Access Policies Tab */}
      {activeTab === 'access-policies' && (
        <div>
          <div style={{ overflowX: 'auto', maxWidth: '100%' }}>
            <DataTable
              data={accessPolicies}
              columns={accessPoliciesColumns}
              title={`Access Policies (${accessPolicies.length} policies)`}
              searchable={false}
              sortable={true}
              exportable={true}
              pagination={true}
              pageSize={10}
              hiddenColumns={['none']}
              onHiddenColumnsChange={() => {}}
            />
          </div>
        </div>
      )}

      {/* Other Tabs */}
      {activeTab === 'user-mapping' && (
        <div style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: '20px',
          boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
          border: '1px solid #e5e7eb',
          minHeight: '300px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '18px',
          color: '#6b7280'
        }}>
          User Mapping Dashboard Coming Soon!
        </div>
      )}

      {activeTab === 'audit-logs' && (
        <div style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: '20px',
          boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
          border: '1px solid #e5e7eb',
          minHeight: '300px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '18px',
          color: '#6b7280'
        }}>
          Audit Logs Dashboard Coming Soon!
        </div>
      )}

      {/* Delete Confirmation Modal */}
      <ConfirmationModal
        isOpen={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onConfirm={handleDeleteConfirm}
        title="Delete Item"
        message={`Are you sure you want to delete "${selectedItem?.providerName || selectedItem?.policyName}"? This action cannot be undone.`}
        confirmText="Delete"
        cancelText="Cancel"
        type="danger"
        isLoading={isDeleting}
      />

      {/* Export Report Modal */}
      <ConfirmationModal
        isOpen={showExportModal}
        onClose={() => setShowExportModal(false)}
        onConfirm={handleExportConfirm}
        title="Export Report"
        message={`Export SSO report for "${selectedItem?.providerName || selectedItem?.policyName}"? This will generate a comprehensive report with authentication details and access policies.`}
        confirmText="Export"
        cancelText="Cancel"
        type="success"
        isLoading={isProcessing}
      />
    </div>
  );
};

export default SSOIntegration;
